import { text } from "./text.i18n";
import { validation } from "./validation.i18n";
/**
 * Language resources for the User module.
 * @typedef {Object} UserLanguageResources
 * @property {Object} text - Text resources for the User module.
 */
export const userLanguage = { text, validation };


